import React from 'react'
import type { AssetTransactionSecurityOption } from '../../../state_manager/data_models/asset_transaction_detail.ts'

// Security <Select> option render + selected-terms summary: the security's
// key commercial terms so an operator can confirm they picked the right
// instrument (same house pattern as the tranche dropdown). Only terms the
// security actually carries are shown.

const money = (v: number | null | undefined, symbol?: string | null): string =>
  `${symbol ?? ''}${Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })}`

const pct = (v: number): string => `${(v * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`

export const securityTermsSummary = (s: AssetTransactionSecurityOption): string => {
  const parts: string[] = []
  if (s.security_type_label) parts.push(s.security_type_label)
  if (s.currency_code) parts.push(s.currency_code)
  if (s.issue_price != null && s.issue_price !== 0) parts.push(`Issue ${money(s.issue_price, s.currency_symbol)}`)
  if (s.nominal_value != null && s.nominal_value !== 0) parts.push(`Nominal ${money(s.nominal_value, s.currency_symbol)}`)
  if (s.valuation_cap != null && s.valuation_cap !== 0) parts.push(`Cap ${money(s.valuation_cap, s.currency_symbol)}`)
  if (s.conversion_discount != null && s.conversion_discount !== 0) parts.push(`Discount ${pct(s.conversion_discount)}`)
  if (s.interest_rate != null && s.interest_rate !== 0) parts.push(`Interest ${pct(s.interest_rate)}`)
  if (s.strike_price != null && s.strike_price !== 0) parts.push(`Strike ${money(s.strike_price, s.currency_symbol)}`)
  if (s.maturity_date) parts.push(`Maturity ${s.maturity_date}`)
  return parts.join(' · ')
}

export const renderSecurityOption = (s: AssetTransactionSecurityOption): React.ReactNode => {
  const terms = securityTermsSummary(s)
  return (
    <div style={{ lineHeight: 1.3, padding: '2px 0' }}>
      <div style={{ fontWeight: 500 }}>{s.label}</div>
      {terms ? <div style={{ fontSize: 12, color: '#8c8c8c' }}>{terms}</div> : null}
    </div>
  )
}

export const securityOptionFilter = (input: string, option?: AssetTransactionSecurityOption): boolean => {
  const q = (input || '').trim().toLowerCase()
  if (!q) return true
  return `${option?.label ?? ''} ${option?.security_type_label ?? ''}`.toLowerCase().includes(q)
}
